import Grid from './Grid';
import Meta from './Meta';
import InternalCard from './Card';
export { CardGridProps } from './Grid';
export { CardMetaProps } from './Meta';
export { CardProps, CardTabListType } from './Card';
const Card = InternalCard;
Card.Grid = Grid;
Card.Meta = Meta;
export default Card;
